import { defineComponent, reactive, ref, toRefs } from "vue";
import { hmdConfirm } from "@/dialog/index";

/**
 * 从合同中选择材料清单
 */
export default defineComponent({
  name: "ContractMaterialSelect",
  props: {
    contractId: {
      type: String,
      required: true,
    },
  },
  emits: ["ok",'close'],
  setup(props, { emit }) {
    const showModal = async () => {
      hmdConfirm({
        com: import("./dialog.vue"),
        params: {
          //@ts-ignore
          contractId:props.contractId,
        },
        confirm:({res})=>{
          emit("ok", res.materials);
        }
      });
    };

    const closeModal = () => {
      emit('close','')
    };
    return {
      showModal,
      closeModal
    };
  },
});
